import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,
  MDBCheckbox,
  MDBIcon,
  MDBBadge
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addImg from "./../components/images/add.svg";
import minusImg from "./../components/images/minus-blue.svg";
import AddMembers from "./../views/AddUsers.js";
import Popup from "./Popup";
import Discount from "./pos/discounts";
import { BasePlanName } from "../utils/BasePlanName";


const PATemplate = (props) => {

  console.log("propspropspropsprops", props);
  const [startDate, setStartDate] = useState(new Date());

  const [showAssociateCheck, setShowAssociateCheck] = useState(false);
  const [alreadysel, setAlreadysel] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [displayMembers, setDisplayMembers] = useState(false);
  const [discountUnit, setDiscountUnit] = useState([]);
  const [discountValues, setDiscountValues] = useState([]);
  const [discountdata, setDiscountdata] = useState({})
  const [selmember, setSelmember] = useState([])

  const [selectedSubplanId, setSelectedSubplanId] = useState("");

  const [currentMembers, setCurrentMembers] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [parentName, setParentName] = useState("")

  const [subplans, setSubplans] = useState([]);

  const [allSubPlan, setAllSubPlan] = useState('')
  const [plans, setPlan] = useState(props?.plansInfo,)
  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    } catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }

  const notSelectedOptions =
    props && props.usersInfo && props.usersInfo.length > 0
      ? props.usersInfo
        .filter((obj) => !selectedOptions.includes(obj._id))
        .map((obj) => obj._id)
      : [];
  if (notSelectedOptions) {
    props.nonselectmem(notSelectedOptions, props.obj._id);
  }

  const handleCheckboxChange = (e, item) => {
    const optionId = item._id;
    if (e.target.checked) {
      // Add the selected option to the array
      setSelectedOptions([...selectedOptions, optionId]);
    } else {
      // Remove the deselected option from the array
      setSelectedOptions(selectedOptions.filter((opt) => opt !== optionId));
    }
  };


  useEffect(() => {
    console.log(props);

    if (props.Alreadyselmem.length > 0) {
      let value = props.Alreadyselmem.find((itm) => itm[0] === props.obj._id);
      if (value) {
        let selectedMembers = value[1];
        setAlreadysel(selectedMembers);
        setCurrentMembers(selectedMembers);
      } else {
        setAlreadysel([]);
        setCurrentMembers([])
      }


    }

    if (props.usersInfo && props.usersInfo.length > 0) {
      setSelectedOptions(props.usersInfo.map((obj) => obj._id));
      setCurrentMembers(props.usersInfo);
    }

  }, [displayMembers]);


  // Add this useEffect to keep currentMembers synchronized
  useEffect(() => {
    if (props.usersInfo && props.usersInfo.length > 0) {
      setCurrentMembers(props.usersInfo);
    }
  }, [props.usersInfo]);

  useEffect(() => {
    setAlreadysel(currentMembers);
  }, [currentMembers]);



  function addSelectedMembers(members) {
    props.onAddMembers(props.obj._id, members, "", showAssociateCheck);
    closeMemPopup();
  }
  function dispMembers(eventObj) {
    eventObj.preventDefault();

    let temSelItme = JSON.parse(localStorage.getItem("selItems"));
    setShowAssociateCheck(
      temSelItme.filter((item) => item.isplan === "1").length > 0 &&
      temSelItme.filter((item) => item.isplan === "0").length > 0 &&
      props.obj.isplan === "1"
    );
    setDisplayMembers(true);
  }
  function closeMemPopup() {
    setDisplayMembers(false);
  }

  function decrementCount(eventObj) {
    //**** Function To remove the selected members***//
    //****Chinna --25-10-2023 ***/
    try {
      let item = props.usersInfo.pop();
      handleDeleteMember(eventObj, item, props.item._id);
      // props.decrementCount(eventObj, props.obj._id);
    } catch (e) { }
  }
  function incrementCount(eventObj) {
    //**** Function To add members again***//
    //****Chinna --25-10-2023 ***/
    dispMembers(eventObj);
    // props.incrementCount(eventObj, props.obj._id);
  }
  function setSDate(date) {
    setStartDate(date);
    try {
      props.setStartDate(date, props.obj._id);
    } catch (e) { }
  }

  let taxPercentage = (props.obj.taxamounts &&
    props.obj.taxamounts.length > 0 &&
    props.obj.taxamounts[props.obj.taxamounts.length - 1].TaxCheck === "Included")
    ?
    Number(props.obj.taxamounts.reduce((acc, obj) => {
      if (obj.percentage) {
        return acc + parseFloat(obj.percentage);
      }
      return acc;
    }, 0)
    )
    : 0;

  const handleDiscountChange1 = (index, value, discountUnit, discountAmount, mid) => {
    setDiscountValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });

    setDiscountUnit((prevUnits) => {
      const updatedUnits = [...prevUnits];
      updatedUnits[index] = discountUnit;
      return updatedUnits;
    });
    // calculateTotalDiscount();
    setDiscountdata(
      {
        mid: mid,
        planid: props.obj._id,
        discountUnit: discountUnit,
        enterdiscount: value,
        discountAmount: discountAmount,
        index: index
      }
    )
    tdiscount(mid, props.obj._id, discountUnit, value, discountAmount);
    console.log("hiiiii", index, value, discountUnit, discountAmount, mid);
  };

  function tdiscount(mid, planid, discountUnit, value, discountAmount) {
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", mid, planid, discountUnit, value, discountAmount);
    props.tdiscount(mid, planid, discountUnit, value, discountAmount);
  }

  function selectedMember(members) {
    setSelmember(members)
  }

  const handleDeleteMember = (e, val, planId) => {
    //**** Function To remove the selected members***//
    //****Chinna --25-10-2023 ***/
    e.preventDefault();
    props.handleDeleteMember(e, val._id, planId);
  };

  const handleDeletePlan = (id) => {
    if (window.confirm("Are you sure you want to delete ?")) {
      console.log("Deleting plan with ID:0000", id);
      props.hadleDeletePlan(id);
    }
  };

 
  const handleChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSubplanId(selectedId);

    const selectedObj =
      subplans.length > 0 && subplans.find(plan => plan._id === selectedId);

    console.log("selectedObj", selectedObj);

    if (!selectedObj) return;

    selectedObj.type = "plan";
    setSelectedPlan(selectedObj);

    // Update parent
    if (props.updateSelectedPlan) {
      props.updateSelectedPlan(props.item._id, selectedObj);
    }

    const currentMembers = props.usersInfo || [];

    currentMembers.forEach((member) => {
      if (!member?.discount) return;

      const { discountType, EnterValue } = member.discount;

      let discountAmount = 0;

      // -------- TAX CALCULATION SAME AS discountValues FUNCTION ----------
      let taxPercent = 0;

      // GST (dgsttax)
      if (props.obj?.taxamounts && props.obj.taxamounts.length > 0) {
        const taxIncluded = props.obj.taxamounts.some(
          (e) => e.TaxCheck === "Included"
        );

        if (taxIncluded) {
          // Sum all tax % values
          taxPercent = props.obj.taxamounts.reduce((acc, obj) => {
            if (obj.percentage && obj.percentage !== "Included") {
              return acc + parseFloat(obj.percentage);
            }
            return acc;
          }, 0);
        }
      }

      console.log("Total Tax %:", taxPercent);

      const price = Number(selectedObj.price);

      // If tax included → remove tax from price
      const priceWithoutTax =
        taxPercent > 0 ? price / (1 + taxPercent / 100) : price;

      console.log("Price Without Tax:", priceWithoutTax);

      if (discountType === "percent") {
        discountAmount = priceWithoutTax * (EnterValue / 100);
      } else {
        discountAmount = Math.min(EnterValue, priceWithoutTax);
      }

      console.log("Final Discount Amount:", discountAmount);

      // Update discount in parent
      props.tdiscount(
        member._id,
        props.obj._id,
        discountType,
        EnterValue,
        discountAmount
      );
    });


    selectPlan(
      null,
      selectedObj.name,
      selectedObj.baseplan,
      selectedObj._id,
      props.item.randomId
    );
  };


  function selectPlan(event, name, id, subplan, randomId) {
    props.onselect(event, id, name, subplan, randomId);
  }

  useEffect(() => {
    const matchingPlan = props.plansInfo.find(
      (plan) => plan._id === props.item.baseplan
    );

    setParentName(matchingPlan?.name)
    const planSubplans = matchingPlan?.subplans || [];
    setAllSubPlan(planSubplans)
    setSubplans(planSubplans);

    if (planSubplans.length > 0) {
      const firstSubplan = planSubplans[0];
      setSelectedSubplanId(firstSubplan._id);
      firstSubplan.type = "plan";
      setSelectedPlan(firstSubplan);

      if (props.updateSelectedPlan) {
        props.updateSelectedPlan(props.item._id, firstSubplan);
      }

    }
  }, [props.item]);





  const getOverdueStartDate = (memberId) => {
    console.log("Checking overdue for member:", memberId);
    console.log("props.obj:", props.obj);
    console.log("Overdue data:", props.obj?.overdueData);

    // Check if overdue data exists
    if (!props.obj?.overdueData) {
      console.log("No overdue data on this item");
      return null;
    }

    // Check if this member has a specific start date
    if (props.obj.overdueData?.memberStartDates?.[memberId]) {
      const dateString = props.obj.overdueData.memberStartDates[memberId].date;
      console.log("Found overdue start date for member:", dateString);
      return new Date(dateString);
    }

    console.log("No overdue start date found for this member");
    return null;
  };


  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <>
      <div className="timegym-home  ">
        <MDBCard className="shadow-4">
          <MDBCardBody>
            <MDBCardTitle>
              {" "}   <div className="d-flex justify-content-between">
                <div>
                
                  <div>
                    {allSubPlan && allSubPlan.length > 0 ? (
                      <>
                        {parentName
                          ? parentName
                          : props.item.name
                            ? props.item.name
                            : props.item.props[0].propname}{" "}
                        <MDBBadge light className="ms-2 varint-badge">
                          Variation
                        </MDBBadge>
                      </>
                    ) : (
                      <>
                        {props.item.name
                          ? props.item.name
                          : props.item.props[0].propname}{" "}
                        <MDBBadge
                          light
                          className="ms-2"
                          color={props.item.type === "plan" ? "primary" : "success"}
                        >
                          {props.item.type === "plan" ? "Plan" : "Addon"}
                        </MDBBadge>
                      </>
                    )}
                  </div>



                </div>
                <button
                  type="button"
                  className="px-2 fs-10 deleteIcon mob-w-10 button-link"
                  onClick={() => handleDeletePlan(props.item._id)}
                >
                  <MDBIcon fas icon="trash" color="##636363" />
                </button>
              </div>
            </MDBCardTitle>
            <MDBCardText>
              <div className="d-flex align-items-center justify-content-between posMobileView">
                <div className="d-flex flex-column justify-content-center align-items-center ">
                  <small> Member(s)</small>
                  <button
                    type="button"
                    className="mt-2 p-0 button-link"
                    onClick={(event) => dispMembers(event)}
                  >
                    <img src={addImg} width="20px" alt="Add" />
                  </button>
                </div>


                {
                  Array.isArray(allSubPlan) && allSubPlan.length > 0 && (
                    <select className="form-select form-select-sm w-25"
                      value={props?.item?._id || ""}

                      onChange={handleChange}
                    >
                      <option value="">Select plan</option>


                      {allSubPlan.map((subplan) => {
                        const baseplanName = BasePlanName(plans, subplan.baseplan);

                        const subplanName = subplan.name?.includes(" - ")
                          ? subplan.name.split(" - ")[1]
                          : subplan.name;

                        const displayName = `${baseplanName}-${subplanName}`
                        return (
                          <option key={subplan._id} value={subplan._id}>
                            {displayName}
                          </option>
                        );
                      })}
                    </select>
                  )
                }




                <div className="d-flex flex-column justify-content-center align-items-center ">
                  <small>Quantity</small>
                  <div className="d-flex mt-2 align-items-center">

                    <button
                      type="button"
                      className="p-0 pe-2 button-link"
                      onClick={(event) => decrementCount(event)}
                    >
                      <img src={minusImg} style={{ cursor: "pointer" }} width="20px" alt="Remove" />
                    </button>
                    <strong className="pe-2">{props.quantity}</strong>

                    <button
                      type="button"
                      className="p-0  button-link"
                      onClick={(event) => incrementCount(event)}
                    >
                      <img src={addImg} style={{ cursor: "pointer" }} width="20px" alt="Add" />
                    </button>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex flex-column justify-content-center align-items-center ">
                    <small>Start Date</small>
                    <div className="mt-2">
                      <div className="mt-2">
                        <DatePicker
                          selected={props.obj.idate ? new Date(props.obj.idate) : startDate}
                          dateFormat="MM-dd-yyyy"
                          className="inp-clrdate-Small"
                          onChange={(date) => setSDate(date)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="d-flex align-items-center fw-bold">
                    &#8377;
                    {props.price ? props?.price?.toLocaleString('en-IN') : props.item?.price?.toLocaleString('en-IN')}
                  </div>
                  {props.tax && (
                    <small className="m-0 mt-2">
                      {" "}
                      {props.item.taxcheck ? `  Included Tax (${taxPercentage}%)` : ""}
                    </small>
                  )}
                </div>
              </div>

              <div className="mt-2">
                {props.usersInfo && props.usersInfo.length > 0 && (
                  <>
                    <strong className="m-0 mb-2">Member(s) Details:</strong>
                    {props.usersInfo.map((item, index) => {
                      // ✅ CORRECT: const declaration inside map's callback function
                      const overdueStartDate = getOverdueStartDate(item._id);

                      return (
                        <div key={item._id} className="d-flex justify-content-between mt-2 align-items-center posMember posMemberMobile">
                          <p className="w-30 w-m mb-0 pb-2">
                            {index + 1}:{item.fname} {item.lname}
                            {item.number ? ", " : ""} {item.number}

                            {/* Display overdue start date if exists */}

                          </p>

                          <div className="d-flex w-30 mob-w-100">
                            <Discount
                              key={item._id}
                              data={item}
                              obj={props.obj}
                              allData={props}
                              index={index}
                              handleDiscountChange={handleDiscountChange1}
                            />
                          </div>
                          <div></div>
                          {overdueStartDate && (
                            <MDBBadge color="success" className="ms-3">
                              plan Start: {formatDate(overdueStartDate)}
                            </MDBBadge>
                          )}

                          <div className="m-0 w-200 mob-w-80">
                            {item.trans &&
                              item.trans.length > 0 &&
                              new Date(item.expirydate) >= new Date() && (
                                <p onChange={(e) => handleCheckboxChange(e, item)}>
                                  <MDBCheckbox
                                    className="me-1"
                                    name="tax"
                                    checked={
                                      new Date(item.expirydate) >= new Date()
                                        ? selectedOptions.includes(item._id)
                                        : false
                                    }
                                    inline
                                    label="Start Simultaneously"
                                  />
                                </p>
                              )}
                          </div>



                          <button
                            type="button"
                            className="px-2 fs-6 deleteIcon mob-w-10 button-link"
                            onClick={(e) => handleDeleteMember(e, item, props.item._id)}
                          >
                            <MDBIcon fas icon="trash" color="##636363" />
                          </button>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </div >

      {displayMembers && (
        <Popup
          title={
            <div className="d-flex">
              Add Member(s)
             
            </div>}
          ptype="modal-lg"
          content={
            <>
              <div>
                <AddMembers
                  id={getToken()}
                  itemid={props.item._id}
                  onAdd={addSelectedMembers}
                  showcheck={showAssociateCheck}
                  // alreadyadded={alreadysel}
                  alreadyadded={currentMembers}
                  selectedMember={selectedMember}
                  plansInfo={props?.plansInfo}

                />
              </div>
            </>
          }
          handleClose={closeMemPopup}
        />
      )
      }
    </>
  );
};

export default PATemplate;
